export function safePathSegment(value) {
  if (value == null) return "";
  const s = String(value);
  return /[/\\?#]/.test(s) ? encodeURIComponent(s) : s;
}
